import React, { useEffect, useState } from "react";
import { TimerIcon } from "lucide-react";
const START_SECONDS = 17 * 60 + 34;
export function CountdownTimer() {
  const [seconds, setSeconds] = useState(START_SECONDS);
  useEffect(() => {
    const id = window.setInterval(() => {
      setSeconds(s => s <= 1 ? START_SECONDS : s - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const h = Math.floor(seconds / 3600);
  const m = Math.floor(seconds % 3600 / 60);
  const s = seconds % 60;
  const parts = [{
    v: h,
    l: "Hours"
  }, {
    v: m,
    l: "Min"
  }, {
    v: s,
    l: "Sec"
  }];
  return <div className="mx-auto mt-5 w-full max-w-xl rounded-2xl bg-plum-950 p-4 text-center" role="timer" aria-live="off" data-id="element-23" data-mp="1adsd6exwf9un">
      <p className="flex items-center justify-center gap-2 text-sm font-bold text-sun" data-id="element-24" data-mp="15f7b09z36g3k">
        <TimerIcon className="h-4 w-4" aria-hidden="true" data-id="element-25" data-mp="34pgwetb5xyku" />
        The $27 offer expires in:
      </p>
      <div className="mt-3 flex items-center justify-center gap-2" data-id="element-26" data-mp="2zsytlyze8ab5">
        {parts.map((p, i) => <React.Fragment key={p.l} data-id="element-27" data-mp="1bzvm5q26hedc" data-mpi={i}>
            <div className="flex w-[72px] flex-col items-center rounded-xl bg-white py-2" data-id="element-28" data-mp="1c31cf8mjmman">
              <span className="font-display text-3xl font-extrabold tabular-nums text-plum-900" data-id="element-29" data-mp="1gxf34xq9g58z">
                {String(p.v).padStart(2, "0")}
              </span>
              <span className="text-[10px] font-bold uppercase text-plum-700" data-id="element-30" data-mp="172df657q197z">{p.l}</span>
            </div>
            {i < parts.length - 1 && <span className="font-display text-2xl font-extrabold text-white" data-id="element-31" data-mp="1utit2eu3prfn">:</span>}
          </React.Fragment>)}
      </div>
    </div>;
}